<script>
  import { onMount } from 'svelte';
  import NavBarReusable from './NavbarReusable.svelte';

  const API_BASE_URL = '/studentplayground';

  let sections = [];
  let loading = false;
  let errorMessage = '';
  let expandedSections = []; // array of section IDs

  async function fetchSections() {
    loading = true;
    errorMessage = '';

    const token = localStorage.getItem('jwtToken');
    if (!token) {
      errorMessage = 'JWT token not found. Please log in.';
      loading = false;
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/api/information-sections/`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        const data = await response.json();
        sections = data.sections || [];
      } else {
        const errorData = await response.json().catch(() => ({}));
        errorMessage = errorData.error || `Failed to fetch sections: ${response.status}`;
      }
    } catch (error) {
      errorMessage = `Network error: ${error.message}`;
    } finally {
      loading = false;
    }
  }

  function toggleSection(sectionId) {
    const index = expandedSections.indexOf(sectionId);
    if (index > -1) {
      expandedSections = [
        ...expandedSections.slice(0, index),
        ...expandedSections.slice(index + 1)
      ];
    } else {
      expandedSections = [...expandedSections, sectionId];
    }
  }

  onMount(() => {
    fetchSections();
  });
</script>

<NavBarReusable label="Bendra Informacija" backLink="/login-greeting" />

<div class="bendra-informacija">
  {#if errorMessage}
    <div class="message error">{errorMessage}</div>
  {/if}

  {#if loading && sections.length === 0}
    <div class="loading">Kraunama...</div>
  {:else if !loading && sections.length === 0 && !errorMessage}
    <div class="empty">Kol kas nėra paskelbtos informacijos.</div>
  {:else}
    <div class="sections-list">
      {#each sections as section (section.id)}
        {@const isExpanded = expandedSections.includes(section.id)}
        <div class="section-card" class:expanded={isExpanded}>
          <button
            type="button"
            class="section-header"
            aria-expanded={isExpanded}
            on:click={() => toggleSection(section.id)}
          >
            <span class="section-topic">{section.topic}</span>
            <span class="chevron" class:expanded={isExpanded} aria-hidden="true">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
          </button>

          {#if isExpanded}
            <div class="section-content">
              <div class="content-wrapper">
                {@html section.content}
              </div>
            </div>
          {/if}
        </div>
      {/each}
    </div>
  {/if}
</div>

<style>
  .bendra-informacija {
    padding: 0 1rem 1rem 1rem;
    max-width: 600px;
    margin: 0 auto;
  }

  .message {
    padding: 12px 16px;
    border-radius: 8px;
    margin-bottom: 16px;
    font-weight: 500;
  }

  .message.error {
    background-color: #f8d7da;
    color: #721c24;
    border: 1px solid #f5c6cb;
  }

  .loading,
  .empty {
    text-align: center;
    padding: 40px 16px;
    color: #666;
    font-size: 16px;
  }

  .sections-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .section-card {
    background: white;
    border: 2px solid #e0e0e0;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16);
  }

  .section-card:hover {
    border-color: #fab45a;
  }

  .section-card.expanded {
    border-color: #fab45a;
  }

  .section-header {
    width: 100%;
    background: transparent;
    border: none;
    padding: 16px 18px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    text-align: left;
  }

  .section-header:focus {
    outline: 2px solid #14695b;
    outline-offset: 2px;
  }

  .section-topic {
    font-size: 18px;
    font-weight: 600;
    color: #333;
  }

  .chevron {
    color: #666;
    transition: transform 0.2s ease;
    flex-shrink: 0;
  }

  .chevron.expanded {
    transform: rotate(180deg);
  }

  .section-content {
    border-top: 1px solid #e0e0e0;
    padding: 0 18px 18px 18px;
  }

  .content-wrapper {
    padding-top: 16px;
    line-height: 1.6;
    color: #333;
  }

  /* Style HTML content similarly to admin view (TinyMCE output) */
  .content-wrapper :global(p) {
    margin-bottom: 1em;
  }

  .content-wrapper :global(ul),
  .content-wrapper :global(ol) {
    margin-bottom: 1em;
    padding-left: 2em;
  }

  .content-wrapper :global(img) {
    max-width: 100%;
    height: auto;
    border-radius: 8px;
    margin: 1em 0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  .content-wrapper :global(a) {
    color: #007bff;
    text-decoration: none;
  }

  .content-wrapper :global(a:hover) {
    text-decoration: underline;
  }

</style>

